import { ActivityHeader } from '@components/Activity/ActivityHeader'
import { ActivityCardMessage } from '@components/Activity/ActivityCardMessage'
import { ActivityDetails } from '@components/Activity/ActivityDetails'
import { QuestionExamples } from '@components/Activity/QuestionExamples'
import { QuestionProvider } from '@contexts/QuestionContext'
import { View, Text, YStack } from 'tamagui'
import { QuestionFooter } from '@components/Activity/QuestionFooter'

// Respostas corretas para demonstração
const correctAnswers = {
  associative: {
    1: { 1: '1', 2: '2', 3: '3' },
  },
  trueFalse: {
    2: 'true',
  },
  multipleChoice: {
    3: '2',
  },
}

export default function Homolog() {
  return (
    <QuestionProvider correctAnswers={correctAnswers} totalPoints={90}>
      <View gap={'$spacing-inset-lg'}>
        <ActivityHeader />

        <YStack gap={'$spacing-inset-xs'}>
          <Text
            ff="$mulishBold"
            fontSize="$font-size-md"
            color="$neutral-800"
            fontWeight={700}
          >
            Nome da aula ou da prova
          </Text>

          <ActivityCardMessage />
        </YStack>

        <ActivityDetails />

        <QuestionExamples />

        <QuestionFooter />
      </View>
    </QuestionProvider>
  )
}
